// extracted by mini-css-extract-plugin
export default {"container":"BlurBackground_container__uzAeS","show":"BlurBackground_show__xeKpx"};